const q = require('queried');
const on = require('emmy/on');
const delegate = require('emmy/delegate');
const emit = require('emmy/emit');
const Search = require('./search');
const _ = require('./i18n');

class OfferSearch extends Search {
  constructor(...args) {
    super(...args);

    this.itemUrlInput = q('[name="item_url"]', this.form);
    this.daysInput = q('[name="days"]', this.form);
    this.offerBindEvents();
    this.renderPreview();
  }

  offerBindEvents() {
    delegate(this.popup, 'click', '.suggestion', (e) => {
      e.preventDefault();
      this.handleSuggestionChoice(e.delegateTarget);
    });

    on(this.queryInput, 'input', () => {
      this.itemUrlInput.value = '';
    });

    on(this.locationInput, 'input', () => this.renderPreview());
    on(this.daysInput, 'input', () => this.renderPreview());
  }

  handleEnterKeydown(suggestion) {
    this.handleSuggestionChoice(suggestion);
  }

  handleSuggestionChoice(suggestion) {
    const itemLink = q('a', suggestion);
    this.queryInput.value = itemLink.textContent;
    // eslint-disable-next-line no-restricted-globals
    this.itemUrlInput.value = `//${location.hostname}${itemLink.getAttribute('href')}`;
    emit(this.form, 'item-chosen');
    this.hidePopup();
  }

  renderPreview() {
    const location = this.locationInput.value;
    const locationFormatted = window.kudago.locations[location].P;
    const days = Math.min(this.daysInput.value, this.daysInput.max);
    const daysWithAmount = _.ngettext('%s day', '%s days', days);
    const daysFormatted = _.interpolate(daysWithAmount, [days]);
    const price = q(`option[value="${location}"]`, this.form).getAttribute('data-price') * days;
    const priceWithAmount = _.ngettext('%s rouble', '%s roubles', price);
    const priceFormatted = _.interpolate(priceWithAmount, [price]);

    const values = [locationFormatted, daysFormatted, priceFormatted];
    q.all('.offer-disclaimer-emphasise', this.form).forEach((item, index) => {
      item.textContent = values[index];
    });
  }

  updateResultsLink() {
    // pass
  }
}

const offer = q('.offer');
if (offer) {
  new OfferSearch(offer);
}
